import Vue from 'www/vue_components'
import vuetify from 'www/modules/vuetify-plugin'
import I18NextVue from 'i18next-vue'
import { initI18n } from 'www/utils'
import PsychDoctorInformation from 'www/vue_components/common/PsychDoctorInformation/PsychDoctorInformation.vue'

const init = async () => {
  const nodes = [...document.querySelectorAll('.vue-psych-doctor-information-mount')]
  const { i18next } = await initI18n({ bundle: 'vue_components/common/PsychDoctorInformation' })

  Vue.use(I18NextVue, { i18next })

  nodes.forEach(el => {
    const VueInstance = new Vue({
      vuetify,
      components: { PsychDoctorInformation },
    })

    VueInstance.$mount(el)
  })
}

init()
